// Las rutas del Catálogo con el agente (ADR-2026-10-13-catalogo-con-el-agente).
export const RUTA_CATALOGO = '/catalogo';
export const rutaDeSesion = (id: string): string => `${RUTA_CATALOGO}/${id}`;
